import { finish, error } from '../../../modules/events/actions/open';

import api from '../../../api';

export function request(dispatch, action) {
    console.trace('REDUX REDUCERS - Load event trace');
    api.get('/events/' + action.id, void 0, { cache: true }).then(
        (data) => dispatch(finish(action.id, data)),
        ({ errors }) => dispatch(error(action.id, errors))
    );
}
